import styled from "vue-styled-components";

const propsButton = {
    display: {
        default: "flex",
        type: String
    },
    alignItems: {
        default: 'center',
        type: String
    },
    height: {
        default: "initial",
        type:String
    },
    color: {
        default: '',
        type: String
    },
    padding: {
        default: "0 1rem",
        type: String
    },
    backgroundColor: {
        default: "white",
        type: String
    },
    backgroundColorHover: {
        default: '',
        type: String
    },
    colorHover: {
        default: '#fff',
        type: String
    },
    borderColor: {
        default: '',
        type: String
    },
    borderColorHover: {
        default: '',
        type: String
    },
    fontSize: {
        default: '',
        type: String
    },
    letterSpacing: {
        default: "0px",
        type: String
    },
    transition: {
        default: "all .5s ease",
        type: String
    },
    cursor: {
        default: "pointer",
        type: String
    },
    textTransform: {
        default: "initial",
        type: String
    },
    margin: {
        default: "0 2px",
        type: String
    },
    minWidth: {
        default: 'unset',
        type: String
    },
    textAlign: {
        default: 'unset',
        type: String
    },
    lineHeight: {
        default: '32px',
        type: String
    },
    justifyContent: {
        default: 'initial',
        type: String
    },
    borderColorFocus: {
        default: '',
        type: String
    },
    backgroundColorFocus: {
        default: '',
        type: String
    },
    colorFocus: {
        default: '#fff',
        type: String
    },
    pointerEvents: {
        default: 'initial',
        type: String
    },
    borderRadius: {
        default: 0,
        type: [Number, String]
    },
    fontSizeCart: {
        default: "1.8rem",
        type: String
    },
    fontWeight: {
        default: '',
        type: String
    }
}

export const CButton = styled('button', propsButton)`
    overflow: visible;

    display: ${props => props.display};
    color: ${props => !props.color ? props.theme.primary_color : props.color};
    align-items: ${props => props.alignItems};
    background-color: ${props => !props.backgroundColor ? '#FFF' : props.backgroundColor};
    border: 1px solid ${props => !props.borderColor ? props.theme.primary_color : props.borderColor};
    padding: ${props => props.padding};
    font: ${props => !props.fontSize ? props.theme.font_size_button : props.fontSize} ${props => props.theme?.products?.button?.font_family ?? props.theme?.footer?.font_family_title ?? props.theme?.font_family}, sans-serif;
    line-height: ${props => props.lineHeight};
    margin: ${props => props.margin};
    cursor: ${props => props.cursor};
    transition: ${props => props.transition};
    text-transform: ${props => !props.textTransform ? 'uppercase' : props.textTransform};
    height: ${props => props.height};
    min-width: ${props => props.minWidth};
    text-align: ${props => props.textAlign};
    border-radius: ${props => !props.borderRadius ? '0px' : props.borderRadius};
    letter-spacing: ${props => props.letterSpacing};
    justify-content: ${props => props.justifyContent};
    pointer-events: ${props => props.pointerEvents};
    font-weight: ${props => !props.fontWeight ? '' : props.fontWeight};
    white-space: nowrap;
    > i {
        &:before {
            margin: 0 4px 0 0;
        }
    }

    &:hover {
        color: ${props => !props.colorHover ? '#fff' : props.colorHover};
        border-color: ${props => !props.borderColorHover ? props.theme.hover : props.borderColorHover};
        background-color: ${props => !props.backgroundColorHover ? props.theme.hover : props.backgroundColorHover};
        text-decoration: none;
    }
    &:focus {
        border-color: ${props => !props.borderColorHover ? props.theme.hover : props.borderColorHover};
        background-color: ${props => !props.backgroundColorHover ? props.theme.hover : props.backgroundColorHover};
        color: ${props => !props.colorHover ? '#fff' : props.colorHover};
        box-shadow: none;
        text-decoration: none;
        outline: none;
    }
    > i {
        font-size: ${props => !props.fontSizeCart ? '1.8rem' : props.fontSizeCart};
        margin-bottom: 2px;

    }
    &:before {
        line-height: ${props => props.lineHeight};
    }
`;

const propsAncora = {
    height: {
        default: "35px",
        type:String
    },
    color: {
        default: '',
        type: String
    },
    colorHover: {
        default: '#fff',
        type: String
    },
    padding: {
        default: ".85rem .5rem",
        type: String
    },
    backgroundColor: {
        default: "white",
        type: String
    },
    backgroundColorHover: {
        default: '',
        type: String
    },
    borderColor: {
        default: "#d4d4d4",
        type: String
    },
    borderColorHover: {
        default: "",
        type: String
    },
    fontSize: {
        default: "1.8rem",
        type: String
    },
    // fontFamily: {
    //     default: '"Oswald",sans-serif',
    //     type: String
    // },
    textTransform: {
        default: "uppercase",
        type: String
    },
    letterSpacing: {
        default: "0px",
        type: String
    },
    borderRadius: {
        default: "0",
        type: [String, Number]
    }
}

export const CAncora = styled('a', propsAncora)`
    position: relative;
    display: -ms-flexbox;
    display: inline-flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    transition: all .3s;
    text-decoration: none;
    text-align: center;
    min-width: 35px;
    font-weight: 400;
    z-index: 2;

    font-family: ${props => props.theme?.products?.button?.font_family ?? props.theme?.footer?.font_family_title ?? props.theme?.font_family}, sans-serif !important;
    text-transform: ${props => !props.textTransform ? 'uppercase' : props.textTransform};
    padding: ${props => props.padding};
    height: ${props => props.height};
    letter-spacing: ${props => props.letterSpacing};
    font-size: ${props => !props.fontSize ? props.theme.font_size_button : props.fontSize};
    color: ${props => !props.color ? props.theme.primary_color : props.color} !important;
    background-color: ${props => !props.backgroundColor ? '#fff' : props.backgroundColor};
    border: 1px solid ${props => !props.borderColor ? props.theme.primary_color : props.borderColor};
    border-radius: ${props => !props.borderRadius ? '0px' : props.borderRadius};

    > span {
        display: inline-block;
    }

    > i {
        &:before {
            margin: 0 4px 0 0;
        }
    }

    &:hover {
        text-decoration: none;
        color: ${props => !props.colorHover ? '#fff' : props.colorHover} !important;
        border-color: ${props => !props.borderColorHover ? props.theme.hover : props.borderColorHover};
        background-color: ${props => !props.backgroundColorHover ? props.theme.hover : props.backgroundColorHover};
    }
    &:focus {
        border-color: ${props => !props.borderColorHover ? props.theme.hover : props.borderColorHover};
        background-color: ${props => !props.backgroundColorHover ? props.theme.hover : props.backgroundColorHover};
        color: ${props => !props.colorHover ? '#fff' : props.colorHover} !important;
        box-shadow: none;
        text-decoration: none;
    }
`;

export const CMobileMenuToggler = styled.button`
    border: 0;
    background: transparent;
    color: ${props => props.theme.cart_icon_color ?? '#333333'};
    padding: 1rem .5rem;
    font-size: 2.1rem;
    line-height: 1;
    display: none;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-right: 1.5rem;
    cursor: pointer;
    > span {
        font-size: 0.9rem;
        text-transform: uppercase;
        display: block;
        color: ${props => props.theme?.header_top?.color ?? '#000'};
    }
    > i {
        &:before {
            margin: 0;
            color: ${props => props.theme?.header_top?.color ?? '#000'};
        }
    }
    &:focus {
        outline:0;
    }

    @media (max-width: 969px) {
        position:unset;
        display:block;
    }

    @media (max-width: 768px) {
        /* margin-right: .6rem;  */
        right:0px;
        /* margin-left: .6rem; */
        margin-inline: 0;
    }
`;

export const CButtonFinalizarPedido = styled.button`
    background: ${props => props.theme?.button_finalizar_pedido?.background_color ?? '#66cc66'};
    border: 1px solid ${props => props.theme?.button_finalizar_pedido?.border_color ?? '#66cc66'};
    text-transform: ${props => props.theme?.button_finalizar_pedido?.text_transform ?? 'none'};
    border-radius: ${props => props.theme?.button_finalizar_pedido?.border_radius ?? '0.25rem'};
    color: ${props => props.theme?.button_finalizar_pedido?.color ?? '#FFF'};
    font: ${props => props.theme?.button_finalizar_pedido?.font_weight ?? 600} ${props => props.theme?.button_finalizar_pedido?.font_size ?? '20px'} ${props => props.theme?.button_finalizar_pedido?.font_family ?? props.theme?.font_family}, sans-serif;


    display: inline-block;
    padding: 7px 0px;
    width: 100%;
    cursor: pointer;
    line-height: 45px;
    letter-spacing: -.0px;
    text-shadow: 1px 1px 0 rgba(0,0,0,0.08);
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    transition: .3s ease;

    &:hover, &:focus {
        background: ${props => props.theme?.button_finalizar_pedido?.background_color_hover ?? '#66cc66'};
        color: ${props => props.theme?.button_finalizar_pedido?.color_hover ?? '#fff'};
        border: 1px solid ${props => props.theme?.button_finalizar_pedido?.border_color_hover ?? '#66cc66'};
        outline: none;
    }
`;

export const CButtonCheckout = styled.button`
    position: relative;
    display: -ms-flexbox;
    display: inline-flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    transition: all .3s;
    text-decoration: none;
    text-align: center;
    min-width: 35px;
    font-weight: ${props => props.theme?.button_checkout?.font_weight ?? '400'};
    z-index: 2;
    height: unset;
    padding: ${props => props.theme?.button_checkout?.padding ?? '.85rem 2rem'};
    font-size: ${props => props.theme?.button_checkout?.font_size ?? '1.8rem'};
    letter-spacing: ${props => props.theme?.button_checkout?.letter_spacing ?? '0.8px'};
    cursor: pointer;
    line-height: normal;

    text-transform: ${props => props.theme?.products?.button?.text_transform ?? 'uppercase'};
    border-radius: ${props => props.theme?.products?.button?.border_radius ?? '0'};
    background-color: ${props => props.theme?.button_checkout?.background_color ?? props.theme?.products?.button?.background_color ?? '#fff'};
    color: ${props => props.theme?.button_checkout?.color ?? props.theme?.products?.button?.color ?? props.theme?.primary_color ?? '#000'} !important;
    font-family: ${props => props.theme?.products?.button?.font_family ?? props.theme?.footer?.font_family_title ?? props.theme?.font_family ?? 'Oswald'}, sans-serif;
    border: 1px solid ${props => props.theme?.button_checkout?.border_color ?? props.theme?.products?.button?.border_color ?? props.theme?.primary_color ?? '000'};

    &:hover,
    &:focus {
        text-decoration: none;
        color: ${props => props.theme?.button_checkout?.color_hover ?? props.theme?.products?.button?.color_hover ?? '#fff'} !important;
        border-color: ${props => props.theme?.button_checkout?.border_color_hover ?? props.theme?.products?.button?.border_color_hover ?? props.theme?.hover ?? '#00b000'};
        background-color: ${props => props.theme?.button_checkout?.background_color_hover ?? props.theme?.products?.button?.background_color_hover ?? props.theme?.hover ?? '#00b000'};
        box-shadow: none;
    }
`
